import { exception } from "@discovery/prelude/lib/data/exception";
const kind = "LookupException";
export const lookupException = exception(kind);

